var stage = "prod";
//var stage = "dev";
var configObject = {
  prod: {
    newApiGateway:
      "https://ghh4h3vwg2.execute-api.ap-south-1.amazonaws.com/prod/lambda",
    newApiKey: "It9ON6uGcW6KyTU3i4NYu8A1EOCujMkyonukSHy6",

    razorKey: "rzp_live_BMb9rwBhKtPb8L",
    razorPaySecretKey: "5Mu80I3LTdwzxITMj2gcuUd3",
    package:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/planAndPricing.json",
    captcha: "6LdZFuwkAAAAAOiSf1RH5_9pt_FTeGFurtQcoQR3",
    cognitoOwner: {
      REGION: "ap-south-1",
      USER_POOL_ID: "ap-south-1_IFyLhICqh",
      APP_CLIENT_ID: "6p2b093b6r0bsn0df48g8kc2ks",
    },
    cognitoEmployee: {
      REGION: "ap-south-1",
      USER_POOL_ID: "ap-south-1_9h9KR16f7",
      APP_CLIENT_ID: "7ak0h84q0sb9vfra8i3mqr42gg",
    },
    uploadTOS3: "https://pgtj1fkue6.execute-api.ap-south-1.amazonaws.com/prod",
    ApiGateway: "https://pgtj1fkue6.execute-api.ap-south-1.amazonaws.com/prod",
    ElasticSearch:
      "https://search-prod-ghoshak-4wpot673rcsasinszx6gk4mdee.ap-south-1.es.amazonaws.com",
    OpenSearch:
      "https://search-alpha-prod-ghsohak-hmr7qymv5sprmyk2fgndusby4q.ap-south-1.es.amazonaws.com",
    openSearchUserName: "ghoshak",
    openSearchPassword: "Ghoshakalpha1!",
    ////////
    json: {
      URL: "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files",
    },
    sweetsAndSnacks:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/productCategorySweetsAndSnacks.json",
    restaurant:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/restaurant.json",
    bakery:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/bakery.json",
    juiceShop:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/juiceShop.json",
    teaShop:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/teaShop.json",
    productCategory:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/productCategory.json",
    fieldsArray:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/fields.json",
    termsAndConditions:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/terms.json",
    productExcel:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/productExcelUploadTemplateNEW.xlsx",
  },
  dev: {
    // //dev
    newApiGateway:
      "https://oq3418l4jh.execute-api.ap-south-1.amazonaws.com/dev/lambda",
    newApiKey: "n75esSYyXz2wQREs6zlHb2iELMATYvIG2MR90Vjr",
    uploadTOS3: "https://pgtj1fkue6.execute-api.ap-south-1.amazonaws.com/prod",
    razorKey: "rzp_test_4faOzBYtbyIP3G",
    razorPaySecretKey: "o03TyEA3AZraEV5gSuP854pd",
    package:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/dev-planAndPricing.json",
    captcha: "6LdD2-skAAAAAD6ZwRD2vwRcROkskouHZD_QBXI_",
    cognitoOwner: {
      REGION: "ap-south-1",
      USER_POOL_ID: "ap-south-1_3oTzsWjgc",
      APP_CLIENT_ID: "64ao0nde52ep9l037k6nqkbn7c",
    },
    cognitoEmployee: {
      REGION: "ap-south-1",
      USER_POOL_ID: "ap-south-1_OjQWY8eo3",
      APP_CLIENT_ID: "6c25mug5qb3n90fvakmld7enoi",
    },
    ApiGateway: "https://2z4hriwfak.execute-api.ap-south-1.amazonaws.com/dev",
    ElasticSearch:
      "https://search-dev-ghoshak-f46izmmagrcg2qa6pfg2dlvuim.ap-south-1.es.amazonaws.com",
    OpenSearch:
      "https://search-dev-ghoshak-f46izmmagrcg2qa6pfg2dlvuim.ap-south-1.es.amazonaws.com",
    openSearchUserName: "devghoshak",
    openSearchPassword: "Devgho1!",

    ////////
    json: {
      URL: "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files",
    },
    sweetsAndSnacks:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/productCategorySweetsAndSnacks.json",
    restaurant:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/restaurant.json",
    bakery:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/bakery.json",
    juiceShop:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/juiceShop.json",
    teaShop:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/teaShop.json",
    productCategory:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/productCategory.json",
    fieldsArray:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/fields.json",
    termsAndConditions:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/json-files/terms.json",
    productExcel:
      "https://prod-ghoshak.s3.ap-south-1.amazonaws.com/productExcelUploadTemplateNEW.xlsx",
  },
};
export const mobileNumberLimit = 10;
export const cardNumberLimit = 4;
export const otpLength = 6;
export const otpDuration = 30; //in seconds
export const defaultLowStockAlert = 5;
export default configObject[stage];
